import { UseQueryOptions } from '@tanstack/react-query';

import { CommunicationType } from 'domains/content/types';
import { CuredApiPaths } from 'models/enums';

import useQuery from '../useQuery';

import QueryKeys from './keys';

const useCommunicationTypesList = (reactQueryOptions?: UseQueryOptions<CommunicationType[], Error>) =>
    useQuery(QueryKeys.COMMUNICATION_TYPES_LIST, CuredApiPaths.COMMUNICATION_TYPES_LIST, reactQueryOptions);

export default useCommunicationTypesList;
